import React from 'react';
import {Button} from 'primereact/button';

interface CenteredButtonProps {
  type?: 'button' | 'submit' | 'reset';
  label: string;
  icon?: string;
  iconPos?: 'left' | 'right';
  onClick?: () => void;
  disabled?: boolean;
}

const CenteredButton: React.FC<CenteredButtonProps> = ({
  type = 'button',
  label,
  icon,
  iconPos = 'left',
  onClick,
  disabled = false
}) => {
  return (
    <Button
      type={type}
      label={label}
      className="w-full bg-gray-800 hover:bg-black text-white font-medium py-3 px-4 rounded-sm transition duration-300 flex items-center justify-center"
      icon={icon}
      iconPos={iconPos}
      onClick={onClick}
      disabled={disabled}
    />
  );
};

export default CenteredButton;
